import { render, staticRenderFns } from "./callai-top.vue?vue&type=template&id=52673cf8&lang=pug&"
import script from "./callai-top.vue?vue&type=script&lang=js&"
export * from "./callai-top.vue?vue&type=script&lang=js&"
import style0 from "./callai-top.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports